import { createListQueryHook } from '@/hooks/lib/createListQueryHook';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import type { ProposalListParams, ProposalListResponse } from '@/types/proposal';

/**
 * Fetches the paginated list of proposals from the operations microservice.
 */
export const useProposals = createListQueryHook<ProposalListParams, ProposalListResponse>({
  queryKey: (params) => opsProposalKeys.list(params),
  endpoint: () => opsProposalEndpoints.list(),
});
